import { jsx as _jsx } from "react/jsx-runtime";
import { ComboboxItem, useComboboxContext } from '@ariakit/react';
import { SelectItem, SelectItemContent } from '../SelectItem';
export const SelectComboboxItem = ({ option, withDivider, }) => {
    const comboboxContext = useComboboxContext();
    const activeValue = comboboxContext?.useState('activeId');
    const isActive = option.value === activeValue;
    return (_jsx(SelectItem, { value: option.value, testId: option.testId, isActive: isActive, asChild: true, children: _jsx(ComboboxItem, { id: option.value, children: _jsx(SelectItemContent, { text: option.text, withDivider: withDivider }) }) }, option.value));
};
